import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import "choerodon-ui/lib/notification/style";
import _notification from "choerodon-ui/lib/notification";
import { getEnvConfig } from "./iocUtils";
import intl from "./intl";
_notification.config({
  placement: 'bottomRight'
});
/**
 * 操作成功通知提示
 * @function success
 * @param {NotificationOptions} options - 默认属性
 * @param {?string} [options.message=操作成功] - 提示信息
 * @param {?string} [options.description] - 详细描述
 */

function success(options) {
  var _ref = options || {},
    message = _ref.message,
    description = _ref.description,
    others = _objectWithoutProperties(_ref, ["message", "description"]);
  var _getEnvConfig = getEnvConfig(),
    notificationDuration = _getEnvConfig.configureParams.notificationDuration;
  _notification.success(_objectSpread({
    message: message || intl.get('hzero.common.notification.success').d('操作成功'),
    description: description,
    duration: notificationDuration || 2.5,
    className: 'success'
  }, others));
}
/**
 * 操作失败通知提示
 * @function error
 * @param {NotificationOptions} options - 默认属性
 * @param {?string} [options.message=操作失败] - 提示信息
 * @param {?string} [options.description] - 详细描述
 */

function error(options) {
  var _ref2 = options || {},
    message = _ref2.message,
    description = _ref2.description,
    others = _objectWithoutProperties(_ref2, ["message", "description"]);
  var _getEnvConfig2 = getEnvConfig(),
    notificationDuration = _getEnvConfig2.configureParams.notificationDuration;
  _notification.error(_objectSpread({
    message: message || intl.get('hzero.common.notification.failed').d('操作失败'),
    description: description,
    duration: notificationDuration || 2.5,
    className: 'error'
  }, others));
}
/**
 * 操作异常通知提示
 * @function warning
 * @param {NotificationOptions} options - 默认属性
 * @param {?string} [options.message=操作异常] - 提示信息
 * @param {?string} [options.description] - 详细描述
 */

function warning(options) {
  var _ref3 = options || {},
    message = _ref3.message,
    description = _ref3.description,
    others = _objectWithoutProperties(_ref3, ["message", "description"]);
  var _getEnvConfig3 = getEnvConfig(),
    notificationDuration = _getEnvConfig3.configureParams.notificationDuration;
  _notification.warning(_objectSpread({
    message: message || intl.get('hzero.common.notification.warn').d('操作异常'),
    description: description,
    duration: notificationDuration || 2.5,
    className: 'warn'
  }, others));
}
/**
 * 操作信息通知提示
 * @function info
 * @param {NotificationOptions} options - 默认属性
 * @param {?string} [options.message] - 提示信息
 * @param {?string} [options.description] - 详细描述
 */

function info(options) {
  var _ref4 = options || {},
    message = _ref4.message,
    description = _ref4.description,
    others = _objectWithoutProperties(_ref4, ["message", "description"]);
  var _getEnvConfig4 = getEnvConfig(),
    notificationDuration = _getEnvConfig4.configureParams.notificationDuration;
  _notification.info(_objectSpread({
    message: message,
    description: description,
    duration: notificationDuration || 2.5,
    className: 'info'
  }, others));
}
/**
 * 关闭信息通知提示
 * @function info
 * @param {string} key - 唯一键
 */

function close(key) {
  _notification.close(key);
}
function autoNotification(type, msg, desc) {
  switch (type) {
    case 'success':
      success({
        message: msg,
        description: desc
      });
      break;
    case 'info':
      info({
        message: msg,
        description: desc
      });
      break;
    case 'warn':
      warning({
        message: msg,
        description: desc
      });
      break;
    case 'error':
      error({
        message: msg,
        description: desc
      });
      break;
    default:
      success({
        message: msg,
        description: desc
      });
      break;
  }
}
export default {
  success: success,
  error: error,
  warning: warning,
  info: info,
  close: close,
  autoNotification: autoNotification
};